export type PrismicLang = "nl-nl" | "en-us"

export const categoriesNlToEn = {
  ringen: "rings",
  armbanden: "bracelets",
  colliers: "necklaces",
  oorbellen: "earrings",
  "losse-items": "separate-items",
  stenen: "gemstones",
  frames: "frames",
  bases: "bases",
  giftcards: "giftcards",
  "nieuwe-collectie": "new-collection",
}
